import { memo, useEffect, useMemo, useRef, useState } from 'react';
import SeletorEquipe, { idsDe, useEquipe } from 'components/shared/SeletorEquipe';
import { getCollaboratorName } from 'utils/collaborators';

const semAcento = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

// Responsáveis do compromisso. A agenda guarda nomes, e-mails e ids em texto
// ("a;b"); aqui a seleção é por id e os três saem sempre na mesma ordem.
function AtribuirResponsavel({ onSelectedUsersChange, initialNames, initialEmails, initialIds, collaborators }) {
  const equipe = useEquipe(Array.isArray(collaborators) && collaborators.length ? collaborators : undefined);
  const [ids, setIds] = useState([]);
  const emitido = useRef('');

  // O que veio do compromisso (ids; senão e-mails; senão nomes) → ids da equipe
  const iniciais = useMemo(() => {
    const porId = idsDe(initialIds);
    if (porId.length) return porId;
    const emails = idsDe(initialEmails).map((e) => e.toLowerCase());
    if (emails.length) return emails.map((e) => equipe.find((c) => String(c.email).toLowerCase() === e)?.id).filter(Boolean).map(String);
    return idsDe(initialNames).map((n) => equipe.find((c) => semAcento(getCollaboratorName(c)) === semAcento(n))?.id).filter(Boolean).map(String);
  }, [initialIds, initialEmails, initialNames, equipe]);

  // Só reaplica quando o compromisso muda de fora (não quando é o eco da nossa própria escolha)
  useEffect(() => {
    const chave = iniciais.join(';');
    if (chave !== emitido.current) setIds(iniciais);
  }, [iniciais]);

  const mudar = (novos, pessoas) => {
    setIds(novos);
    const ordem = [...pessoas].sort((a, b) => getCollaboratorName(a).localeCompare(getCollaboratorName(b), 'pt-BR', { sensitivity: 'base' }));
    emitido.current = ordem.map((p) => String(p.id)).join(';');
    onSelectedUsersChange?.({
      names: ordem.map(getCollaboratorName).join(';'),
      emails: ordem.map((p) => p.email).join(';'),
      ids: emitido.current,
    });
  };

  return <SeletorEquipe value={ids} onChange={mudar} equipe={equipe} size='large' style={{ width: '100%', marginBottom: 16 }} placeholder='Responsáveis' />;
}

export default memo(AtribuirResponsavel);
